import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TermDateFormatter from '../../../../../../components/TermDate/TermDate';
import { useSelector } from 'react-redux';

const TermInfoCardDate = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 1.375rem;
  border-bottom: 0.0625rem solid #cccccc;
  margin-bottom: 0.625rem;
  width: 100%;

  svg {
    width: 0.9375rem;
  }

  p {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 120%;
    letter-spacing: 0.0015em;
    color: #585858;
    margin-bottom: 0;
  }
`;

const TermDate = styled.span`
  font-weight: 700;
`;

const Weeks = styled.span`
  margin-left: 0.125rem;
`;

export default function Date({ startDate, endDate, useExactDates, weeks }) {
  const timezone = useSelector(state => state.profile.orgTimezone);

  return (
    <TermInfoCardDate>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16" aria-hidden="true">
        <path
          d="M14.063 4.157c0-.48-.198-.94-.55-1.278a1.91 1.91 0 0 0-1.325-.53h-.47v-.44a.468.468 0 0 0-.632-.435.472.472 0 0 0-.267.245.44.44 0 0 0-.038.178v.452H4.22v-.44a.468.468 0 0 0-.633-.435.472.472 0 0 0-.267.245.438.438 0 0 0-.038.178v.452h-.469c-.497 0-.974.19-1.325.53-.352.339-.55.798-.55 1.278v.339c0 .03.013.058.035.08a.12.12 0 0 0 .083.033h12.89a.12.12 0 0 0 .083-.033.11.11 0 0 0 .034-.08v-.34ZM.938 12.291c0 .48.197.94.549 1.278.351.34.828.53 1.325.53h9.376c.497 0 .974-.19 1.325-.53.352-.339.55-.798.55-1.278V5.597a.084.084 0 0 0-.026-.06.09.09 0 0 0-.062-.024H1.025a.09.09 0 0 0-.062.024.083.083 0 0 0-.025.06v6.694Zm10.078-5.875c.139 0 .275.04.39.115.116.074.206.18.26.304a.655.655 0 0 1-.153.739.727.727 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .087-.856.717.717 0 0 1 .498-.199Zm0 2.26c.139 0 .275.04.39.114.116.075.206.18.26.304a.655.655 0 0 1-.153.74.728.728 0 0 1-.766.147.699.699 0 0 1-.316-.25.66.66 0 0 1 .087-.857.717.717 0 0 1 .498-.198Zm-2.344-2.26c.139 0 .275.04.39.115.116.074.206.18.26.304a.655.655 0 0 1-.153.739.727.727 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .088-.856.717.717 0 0 1 .497-.199Zm0 2.26c.139 0 .275.04.39.114.116.075.206.18.26.304a.655.655 0 0 1-.153.74.728.728 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .088-.857.717.717 0 0 1 .497-.198Zm0 2.26c.139 0 .275.04.39.114.116.074.206.18.26.304a.655.655 0 0 1-.153.739.727.727 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .088-.856.716.716 0 0 1 .497-.199Zm-2.344-2.26c.14 0 .275.04.39.114.116.075.207.18.26.304a.655.655 0 0 1-.153.74.728.728 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .088-.857.717.717 0 0 1 .497-.198Zm0 2.26c.14 0 .275.04.39.114.116.074.207.18.26.304a.655.655 0 0 1-.153.739.727.727 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .088-.856.716.716 0 0 1 .497-.199Zm-2.344-2.26c.14 0 .275.04.391.114.116.075.206.18.259.304a.655.655 0 0 1-.152.74.728.728 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .087-.857.717.717 0 0 1 .497-.198Zm0 2.26c.14 0 .275.04.391.114.116.074.206.18.259.304a.655.655 0 0 1-.152.739.727.727 0 0 1-.766.147.698.698 0 0 1-.316-.25.66.66 0 0 1 .087-.856.716.716 0 0 1 .497-.199Z"
          fill="#446372"
        />
      </svg>
      <p>
        <TermDate>
          <TermDateFormatter
            startDate={startDate}
            endDate={endDate}
            dateType="monthYear"
            exactDates={useExactDates}
            timezone={timezone}
          />
          ;
        </TermDate>
        <Weeks>{weeks} weeks</Weeks>
      </p>
    </TermInfoCardDate>
  );
}

Date.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  useExactDates: PropTypes.bool.isRequired,
  weeks: PropTypes.string.isRequired,
};
